export default __webpack_public_path__ + "static/media/white-play.e14c34dc.png";